import { cn } from "cn";
import type * as React from "react";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        /* sorted */
        "flex",
        "field-sizing-content min-h-16 w-full",
        "px-3 py-2",
        "text-base",
        "border-border-dark-low bg-transparent rounded-md border shadow-xs outline-none",
        "transition-[color,box-shadow]",
        "placeholder:text-text-dark-low focus-visible:border-border-dark-max aria-invalid:border-border-negative disabled:cursor-not-allowed disabled:opacity-50",
        "md:text-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
